// !!todo update with actual copy
export const PROFICIENCY_LEVELS = {
  0: 'Unranked',
  1: 'Beginner',
  2: 'Intermediate',
  3: 'Advanced'
} as const;

export const MINIMIZED_HERO_HEIGHT = 62;

export const GROUP_BY_OPTIONS = {
  SKILL: 'skill',
  STANDARD: 'standard'
} as const;
